// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2uNNv","large":"styles_large__JkJ7v"};